import { executeRequest, JFSRequest } from '@jfs/network'
import { isSuccessResponse } from './../utils/index'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'

const responseParser = (response: any) => {
  const data = isSuccessResponse(response)
  const respData = {
    id: '' + data?.packageId,
    fileName: data?.fileName,
    rules: data?.rules,
  }

  return respData
}

const getAllByFile = (fileName: string, tokens: any) => {
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.getAllByFile),
    method: 'GET',
    cache: false,
    config: sitConfig(tokens),
    headers: getHeaders(),
    body: {
      fileName,
    },
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { getAllByFile }
